"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _logo = _interopRequireDefault(require("../logo"));

var _footerSection = _interopRequireDefault(require("./footer-section"));

var _index = _interopRequireDefault(require("./index.scss"));

var SiteFooter = function SiteFooter(_ref) {
  var _classNames;

  var className = _ref.className,
      colour = _ref.colour,
      content = _ref.content,
      links = _ref.links,
      showAngle = _ref.showAngle;
  return _react["default"].createElement("footer", {
    className: (0, _classnames["default"])(_index["default"].SiteFooter, className, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, _index["default"].showAngle, showAngle), (0, _defineProperty2["default"])(_classNames, _index["default"].seasonal, showAngle && colour === 'seasonal'), (0, _defineProperty2["default"])(_classNames, _index["default"].brand, showAngle && colour === 'brand'), _classNames)),
    role: "contentinfo"
  }, _react["default"].createElement(_container["default"], {
    className: _index["default"].container,
    type: "large"
  }, content && _react["default"].createElement(_footerSection["default"], null, content), _react["default"].createElement(_footerSection["default"], {
    className: _index["default"].linksSection
  }, _react["default"].createElement(_logo["default"], {
    type: "alt",
    className: _index["default"].logo
  }), _react["default"].createElement("div", {
    className: _index["default"].linksWrapper
  }, links && _react["default"].createElement("ul", {
    className: _index["default"].linksList
  }, links.map(function (_ref2) {
    var label = _ref2.label,
        href = _ref2.href;
    return _react["default"].createElement("li", {
      key: href
    }, _react["default"].createElement("a", {
      href: href,
      className: _index["default"].link
    }, label));
  })), _react["default"].createElement("span", {
    className: _index["default"].rightsText
  }, _react["default"].createElement("span", null, "\xA9 All rights reserved."), _react["default"].createElement("a", {
    href: "https://www.scentregroup.com",
    className: _index["default"].rightsTextLink
  }, "Scentre Group"), _react["default"].createElement("span", null, new Date().getFullYear()))))));
};

SiteFooter.propTypes = {
  className: _propTypes.string,
  showAngle: _propTypes.bool,
  colour: (0, _propTypes.oneOf)(['brand', 'seasonal']),
  content: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]),
  links: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    href: _propTypes.string.isRequired
  }))
};
SiteFooter.defaultProps = {
  className: null,
  showAngle: true,
  colour: 'seasonal',
  links: []
};
var _default = SiteFooter;
exports["default"] = _default;